import { Box, Divider } from '@mui/material';
import Stack from '@mui/material/Stack';
import { colors, Typography } from '@sweep-io/sweep-design';

const RedDot = () => (
  <Box
    sx={{
      width: '3px',
      height: '3px',
      borderRadius: '50%',
      backgroundColor: colors.feedback.destructive,
    }}
  />
);

interface BestPracticeSelectorsWrapperProps {
  isEditMode: boolean;
  severityJsx: React.ReactNode;
  resourceJsx: React.ReactNode;
}

export const BestPracticeSelectorsWrapper = ({
  isEditMode,
  severityJsx,
  resourceJsx,
}: BestPracticeSelectorsWrapperProps) => {
  const labelsColor = isEditMode ? colors.grey[700] : colors.grey[500];
  const labelsVariant = isEditMode ? 'caption' : 'caption-medium';
  return (
    <Stack direction="row" gap={2}>
      <Stack direction="row" gap={0.5} alignItems="center">
        <Typography variant={labelsVariant} color={labelsColor}>
          Impact{isEditMode ? '' : ':'}
        </Typography>
        {isEditMode && <RedDot />}
        {severityJsx}
      </Stack>
      {!isEditMode && <Divider orientation="vertical" flexItem />}
      <Stack direction="row" gap={0.5} alignItems="center">
        <Typography variant={labelsVariant} color={labelsColor}>
          Configuration Type{isEditMode ? '' : ':'}
        </Typography>
        {isEditMode && <RedDot />}
        {resourceJsx}
      </Stack>
    </Stack>
  );
};
